import React, { useState } from 'react';
import { updateStorage, getDefaultValue } from '../../services/storageManager'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/fr';

const PICKER_POPUP_Z_INDEX = 10002;

const toSxArray = (sx) => {
    if (!sx) return [];
    return Array.isArray(sx) ? sx : [sx];
};

const getViews = (views) => {
    if (!views) {
        return ['day', 'month', 'year'];
    }

    return views.split(',').map((view) => view.trim()).filter(Boolean);
};

const getInitialDateValue = (storedValue, yearOnly) => {
    if (storedValue === undefined || storedValue === null || storedValue === '') {
        return null;
    }

    if (yearOnly) {
        const storedYear = Number(storedValue);
        if (Number.isInteger(storedYear) && storedYear > 0) {
            return dayjs().year(storedYear).startOf('year');
        }
    }

    const parsedDate = dayjs(storedValue);
    if (!parsedDate.isValid()) {
        return null;
    }

    return yearOnly ? parsedDate.startOf('year') : parsedDate;
};

const getStorageValue = (dateValue, views) => {
    const normalizedDate = views.includes('day')
        ? dateValue.startOf('day')
        : views.includes('month')
            ? dateValue.startOf('month')
            : dateValue.startOf('year');

    return normalizedDate.format('YYYY-MM-DDTHH:mm:ssZ');
};

export default function Calendar({ application, category, name, views, ...props }) {
    const arrayOfViews = getViews(views);
    const yearOnly = arrayOfViews.length === 1 && arrayOfViews[0] === 'year';
    const [selectedDate, setSelectedDate] = useState(() => getInitialDateValue(getDefaultValue(application, category, name), yearOnly));
    const { slotProps, sx, ...datePickerProps } = props;
    const popupLayerSx = { zIndex: PICKER_POPUP_Z_INDEX };

    const handleDateChange = (newDate) => {
        if (!newDate || !newDate.isValid()) {
            setSelectedDate(null);
            updateStorage(application, category, name, null);
            return;
        }

        setSelectedDate(newDate);
        updateStorage(application, category, name, getStorageValue(newDate, arrayOfViews));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
            <DatePicker
                views={arrayOfViews}
                value={selectedDate}
                onChange={handleDateChange}
                sx={[
                    { width: '100%' },
                    ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
                ]}
                slotProps={{
                    ...slotProps,
                    textField: {
                        fullWidth: true,
                        size: 'small',
                        ...slotProps?.textField
                    },
                    popper: {
                        ...slotProps?.popper,
                        sx: [
                            popupLayerSx,
                            ...toSxArray(slotProps?.popper?.sx)
                        ]
                    },
                    desktopPaper: {
                        ...slotProps?.desktopPaper,
                        sx: [
                            ...toSxArray(slotProps?.desktopPaper?.sx)
                        ]
                    },
                    dialog: {
                        ...slotProps?.dialog,
                        sx: [
                            popupLayerSx,
                            ...toSxArray(slotProps?.dialog?.sx)
                        ]
                    }
                }}
                {...datePickerProps}
            />
        </LocalizationProvider>
    );
}
